module.exports = __webpack_public_path__ + "img/berman.7427799a.png";